import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutMiscInvoiceTaxHistoryTable extends Layout {
    sourceExcisetaxMiscBillHist: DataSource;
    tableExciseTaxes: Table;
}
